import React, { useEffect, useRef, useState } from "react";
import { FormGroup } from "reactstrap";
import { File } from "../Files";
import { Grid, IconButton, Menu, MenuItem } from "@mui/material";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import AddIcon from "@mui/icons-material/Add";
import AxiosInstance from "../../utils/axiosInstance";
import { handleAuth } from "../Login/Auth";
import { useLocation, useNavigate } from "react-router-dom";
import InputText from "../InputFields/InputText";
import AddItems from "../../Views/Admin/Setting/Materials&Labor/AddItems";
import { Row, Col } from "react-bootstrap";
import "./style.css";
import { NoDataFound } from "../ContractComponent/Index";
import DollerInput from "../../components/InputFields/Doller";
import FormSectionCard from "../FormShell/FormSectionCard";
import MaterialsLaborSelect, {
  MaterialsLaborOption,
} from "./MaterialsLaborSelect";
import WhiteButton from "../Button/WhiteButton";
import { getItem } from "../../utils/storage";
import showToast from "../Toast/Toster";

const GetProducts = ({
  item,
  index,
  handleSelectChange,
  lineItems,
  setLineItems,
  menuIsOpen,
  setMenuIsOpen,
  deleteLineItem,
  isError,
  submitAttempted,
  touchedLineItems,
  setTouchedLineItems,
}) => {
  
  const location = useLocation();
  const navigate = useNavigate();
  const baseUrl = import.meta.env.VITE_BASE_API;
  const [groupedOptions, setGroupedOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [tokenDecode, setTokenDecode] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await handleAuth(navigate, location);
        setTokenDecode(res.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  const getProducts = async () => {
    try {
      const res = await AxiosInstance.get(
        `/v1/material/get_material/${
          getItem("CompanyId") || tokenDecode?.CompanyId
        }`
      );
      if (res.data.statusCode === 200) {
        const products = res.data.data;
        
        // 🔍 DEBUG: Track materials fetched from API
        
        products.forEach((group) => {
          if (group.options) {
            group.options.forEach((option) => {
              
            });
          }
        });
        
        setGroupedOptions(products);
      }
    } catch (error) {
      console.error("Error: ", error);
    }
  };
  useEffect(() => {
    getProducts();
  }, [tokenDecode]);

  const handleInputChange = (e, key) => {
    const newLineItems = [...lineItems];
    let value = e.target.value;

    if (key === "Sq. Ft.") key = "Unit";

    if (key === "Description" && value.startsWith(" ")) {
      value = value.trimStart();
    }

    if (
      key === "Hourly" &&
      (value === "" || value === null || value === undefined)
    ) {
      value = "1";
    }

    newLineItems[index][key] = value;

    // JOB-3383: `Number(raw) || 1` collapsed an explicit 0 (e.g. the
    // negative-then-clamped-to-0 case) into 1, so Total kept rendering
    // the prior `1 * price` value instead of $0.00. Treat empty / non-
    // numeric input as "default to 1 unit" but pass 0 through.
    const normalizeQty = (raw) => {
      if (raw === "" || raw === null || raw === undefined) return 1;
      const n = Number(raw);
      if (!Number.isFinite(n)) return 1;
      return Math.max(0, n);
    };

    let quantity = 1;
    let price = 0;

    switch (currentUnitType) {
      case "Unit":
        quantity = normalizeQty(newLineItems[index]?.Unit);
        price = Number(newLineItems[index]?.CostPerUnit) || 0;
        break;
      case "Hourly":
        quantity = normalizeQty(newLineItems[index]?.Hourly);
        price = Number(newLineItems[index]?.CostPerHour) || 0;
        break;
      case "Fixed":
        quantity = normalizeQty(newLineItems[index]?.Fixed);
        price = Number(newLineItems[index]?.CostPerFixed) || 0;
        break;
      case "Square":
        quantity = normalizeQty(newLineItems[index]?.Square);
        price = Number(newLineItems[index]?.CostPerSquare) || 0;
        break;
      case "Sq. Ft.":
        quantity = normalizeQty(newLineItems[index]?.Unit);
        price = Number(newLineItems[index]?.CostPerSquare) || 0;
        break;
      default:
        break;
    }

    newLineItems[index].Total = quantity * price;

    setLineItems(newLineItems);
  };

  const handleSearchInputChange = (value) => {
    setInputValue(value);
  };
  const filteredOptions = groupedOptions?.filter((group) =>
    group.options.some(
      (option) =>
        option.Name?.toLowerCase().includes(inputValue?.toLowerCase()) ||
        option.Description?.toLowerCase().includes(inputValue?.toLowerCase())
    )
  );

  /** Resolve the catalog option that backs this line item. The find previously
   * matched by Name only, which left the first line item blank whenever the
   * catalog entry had been renamed/case-shifted after the quote was saved. */
  const selectedOption = React.useMemo(() => {
    const flat = (groupedOptions || []).flatMap((g) => g?.options || []);
    if (!flat.length) return null;
    const itemProductId = item?.ProductId;
    if (itemProductId) {
      const byProductId = flat.find(
        (o) => o?.ProductId && String(o.ProductId) === String(itemProductId)
      );
      if (byProductId) return byProductId;
    }
    const itemName = (item?.Name || "").trim().toLowerCase();
    if (!itemName) return null;
    return (
      flat.find((o) => (o?.Name || "").trim().toLowerCase() === itemName) ||
      null
    );
  }, [groupedOptions, item?.ProductId, item?.Name]);

  /** When the catalog no longer contains the saved material (deleted/renamed),
   * still show the saved name so the field is not empty. */
  const displayValue =
    selectedOption ||
    (item?.Name
      ? {
          Name: item.Name,
          Description: item?.Description || "",
          ProductId: item?.ProductId,
          IsNonTaxable: item?.IsNonTaxable,
        }
      : null);
  const [modelOpen, setModelOpen] = useState(false);
  const [selectedProductAndService, setSelectedProductAndService] =
    useState(null);
  const productsAndService = [{ Type: "Materials" }, { Type: "Labor" }];

  const UnitsAndHours = [
    ...(selectedProductAndService?.Type === "Materials"
      ? [{ Type: "Unit" }, { Type: "Sq. Ft." }]
      : []),
    ...(selectedProductAndService?.Type === "Labor"
      ? [{ Type: "Hourly" }, { Type: "Fixed" }]
      : []),
  ];

  const [selectedUnitsAndHours, setSelectedUnitsAndHours] = useState(null);
  const [showHoursSection, setShowHoursSection] = useState(false);
  const [showSquaresSection, setShowSquaresSection] = useState(false);
  const [showFixedSection, setShowFixedSection] = useState(false);
  const [showUnitsSection, setShowUnitsSection] = useState(false);

  const [openDropdown, setOpenDropdown] = useState(false);
  // JOB-3432: anchor for the unit-type popover. The chevron button is the
  // anchor; using anchorEl avoids the prior pattern of rendering a second
  // InputText below the qty input (which looked like a duplicate field).
  const [unitMenuAnchor, setUnitMenuAnchor] = useState(null);
  const [currentUnitType, setCurrentUnitType] = useState("");

  // JOB-3384: the unit-type chevron opens a panel inside this column; it
  // previously stayed open forever because nothing dismissed it. Close on
  // any pointerdown outside the qty column (which contains both the
  // chevron trigger and the dropdown). Also close on scroll so the panel
  // doesn't visually trail along when the page scrolls.
  const unitDropdownRef = useRef(null);
  useEffect(() => {
    if (!openDropdown) return undefined;
    const handlePointerDown = (e) => {
      if (
        unitDropdownRef.current &&
        !unitDropdownRef.current.contains(e.target)
      ) {
        setOpenDropdown(false);
      }
    };
    const handleScroll = () => setOpenDropdown(false);
    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("touchstart", handlePointerDown);
    window.addEventListener("scroll", handleScroll, true);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("touchstart", handlePointerDown);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [openDropdown]);

  // File handling state and functions for AddItems modal
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [previewFile, setPreviewFile] = useState(null);
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedAdminId, setSelectedAdminId] = useState("");
  const [searchInput, setSearchInput] = useState("");

  const allowedFileTypes = ["image/jpeg", "image/png", "image/jpg"];
  const cdnShowUrl = `${baseUrl}/v1/cdn/upload`;

  const uploadFile = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await AxiosInstance.post(
        `/v1/cdn/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return response?.data?.filePath;
    } catch (error) {
      const msg = (error?.response?.data?.message || "").toString();
      const isFileTooLarge =
        error?.response?.status === 413 ||
        (error?.response?.status === 400 && /file size too large/i.test(msg));
      if (isFileTooLarge) {
        // Toast already shown by AxiosInstance interceptor
      }
      throw error;
    }
  };

  const uploadImage = async (file) => {
    try {
      const formData = new FormData();
      formData.append("files", file);
      const response = await AxiosInstance.post(
        `/v1/cdn/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response?.data?.files?.length > 0) {
        const imagePath = response?.data?.files[0]?.filename;
        setFile(imagePath);
        setError("");
      } else {
        throw new Error("No file returned from CDN.");
      }
    } catch (error) {
      const msg = (error?.response?.data?.message || "").toString();
      const isFileTooLarge =
        error?.response?.status === 413 ||
        (error?.response?.status === 400 && /file size too large/i.test(msg));
      if (isFileTooLarge) {
        setError("File size too large");
        // Toast already shown by AxiosInstance interceptor
      } else {
        setError("There was an issue uploading the file. Please try again.");
      }
      setFile(null);
    }
  };

  const handleFileChange = (event, isExistingAttachment = false) => {
    if (isExistingAttachment && typeof event === "string") {
      setFile(event);
      setError("");
      return;
    }
    const selectedFile = event?.target?.files[0];
    if (selectedFile) {
      if (allowedFileTypes?.includes(selectedFile?.type)) {
        uploadImage(selectedFile);
      } else {
        setError("Unsupported file type. Please upload a JPEG, PNG file.");
        setFile(null);
      }
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    setFile("");
    setError("");
  };

  const handleFilePreview = (filePath) => {
    if (!filePath) {
      console.error("No file to preview");
      return;
    }
    const fullPath = `${cdnShowUrl}/${filePath}`;
    setPreviewFile(fullPath);
    setPreviewModalOpen(true);
  };

  const closePreviewModal = () => {
    setPreviewFile(null);
    setPreviewModalOpen(false);
  };

  const handleCloseModal = () => {
    handleRemoveFile();
    setModelOpen(false);
    setSelectedProduct(null);
    setSelectedUnitsAndHours("");
    setSelectedProductAndService(null);
    setShowUnitsSection(false);
    setShowHoursSection(false);
    setShowSquaresSection(false);
    setShowFixedSection(false);
    setSelectedAdminId("");
  };

  /** Add-items modal: file drop zone (not line-item reorder). */
  const handleFileDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleFileDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const f = e.dataTransfer?.files?.[0];
    if (f) {
      handleFileChange({ target: { files: [f] } });
    }
  };

  useEffect(() => {
    // JOB-3386: previously this used `!== null`, which matched the
    // empty-string default that emptyLine() seeds on every cost field
    // (and that the API echoes back). On edit-load CostPerHour was ""
    // — `"" !== null` is true — so every line item resolved to
    // "Hourly", which hid the Unit/Price/Total inputs and made the
    // values look blank. Use a real "has a value" check so the type
    // is picked from the field that actually holds data.
    const hasValue = (v) => v !== null && v !== undefined && v !== "";
    if (hasValue(item?.CostPerHour)) {
      setCurrentUnitType("Hourly");
    } else if (hasValue(item?.CostPerUnit)) {
      setCurrentUnitType("Unit");
    } else if (hasValue(item?.CostPerSquare)) {
      // Square vs Sq. Ft. share the same cost field; the qty field
      // (Square vs Unit) is what distinguishes them.
      setCurrentUnitType(hasValue(item?.Square) ? "Square" : "Sq. Ft.");
    } else if (hasValue(item?.CostPerFixed)) {
      setCurrentUnitType("Fixed");
    } else {
      setCurrentUnitType("Hourly");
    }
  }, [item]);

  const handleDropdownToggle = (event) => {
    // JOB-3432: capture the chevron node so the popover can anchor to it.
    if (event && event.currentTarget) setUnitMenuAnchor(event.currentTarget);
    setOpenDropdown(!openDropdown);
  };

  const handleDropdownChange = (event) => {
    const value = event.target.value;
    const newLineItems = [...lineItems];
    if (value === "Square") {
      newLineItems[index].Hourly = null;
      newLineItems[index].Fixed = null;
      newLineItems[index].Unit = null;
      newLineItems[index].Square = "1";
      newLineItems[index].Total =
        Number(newLineItems[index].Square || 1) *
        Number(newLineItems[index].CostPerSquare || 0);
    } else if (value === "Sq. Ft.") {
      newLineItems[index].Hourly = null;
      newLineItems[index].Fixed = null;
      newLineItems[index].Square = null;
      newLineItems[index].Unit = "1";
      newLineItems[index].Total =
        Number(newLineItems[index].Unit || 1) *
        Number(newLineItems[index].CostPerSquare || 0);
    } else if (value === "Hourly") {
      newLineItems[index].Square = null;
      newLineItems[index].Unit = null;
      newLineItems[index].Fixed = null;
      newLineItems[index].Hourly = "1";
    } else if (value === "Fixed") {
      newLineItems[index].Square = null;
      newLineItems[index].Unit = null;
      newLineItems[index].Hourly = null;
      newLineItems[index].Fixed = "1";
    } else if (value === "Unit") {
      newLineItems[index].Square = null;
      newLineItems[index].Hourly = null;
      newLineItems[index].Fixed = null;
      newLineItems[index].Unit = "1";
    }
    setLineItems(newLineItems);
    setCurrentUnitType(value);
    setOpenDropdown(false);
  };

  const handleMoveUp = () => {
    if (index > 0) {
      const newLineItems = [...lineItems];
      const temp = newLineItems[index];
      newLineItems[index] = newLineItems[index - 1];
      newLineItems[index - 1] = temp;
      setLineItems(newLineItems);
    }
  };

  const getPlaceholderText = (unitType) => {
    const placeholders = {
      "Unit": "Enter unit here",
      "Hourly": "Enter hours",
      "Fixed": "Enter fixed amount here",
      "Sq. Ft.": "Enter square feet here",
      "Square": "Enter square here"
    };
    return placeholders[unitType] || "Enter value here";
  };
    
  const qtyKey = currentUnitType === "Sq. Ft." ? "Unit" : currentUnitType;

  const markFieldTouched = (fieldName) => {
    if (setTouchedLineItems) {
      setTouchedLineItems((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [fieldName]: true,
        },
      }));
    }
  };

  const isFieldTouched = (fieldName) => {
    return touchedLineItems?.[index]?.[fieldName] === true;
  };

  /** Same default as qty field value — avoids false errors when API omits quantity (e.g. sq.-ft. materials). */
  const qtyDisplayValue =
    item[qtyKey] !== undefined && item[qtyKey] !== null
      ? item[qtyKey]
      : "1";
  const qtyNum = Number(qtyDisplayValue);
  const qtyFieldInvalid =
    (submitAttempted || isFieldTouched(qtyKey)) &&
    (qtyDisplayValue === "" ||
      Number.isNaN(qtyNum) ||
      qtyNum <= 0);

  const nameFieldInvalid =
    (submitAttempted || isFieldTouched("Name")) &&
    (!item?.Name || item?.Name === "");

  return (
    <Row
      className="row getproduct"
      style={{
        paddingRight: "7px",
        paddingLeft: "0",
        position: "relative",
        borderRadius: "4px",
        marginBottom: "12px",
      }}
    >
      <Col
        className="col-lg-5 col-md-12 col-sm-12 col-12"
        style={{ paddingRight: "3px", paddingLeft: "0" }}
        lg={5}
        md={12}
        sm={12}
        xs={12}
      >
        <FormSectionCard
          className="cs-form-section--line-item"
          subtitle={
            <span
              className={[
                "gl-line-item-materials-subtitle",
                nameFieldInvalid ? "gl-line-item-materials-subtitle--error" : "",
              ]
                .filter(Boolean)
                .join(" ")}
            >
              Enter Materials and Labor{" "}
              <span className="cs-field-label-required" aria-hidden="true">
                *
              </span>
            </span>
          }
          contentClassName="gl-line-item-materials-body"
          noBorder
        >
          <div className="gl-line-item-select-wrap">
            <MaterialsLaborSelect
              className="basic-single gl-line-item-select react-select-container"
              hasError={nameFieldInvalid}
              placeholder="Enter materials and labor"
              options={filteredOptions}
              components={{
                Option: MaterialsLaborOption,
                NoOptionsMessage: () => (
                  <Grid
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "20px",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <NoDataFound />
                    <WhiteButton
                      onClick={() => {
                        setModelOpen(true);
                        setSelectedProduct(null);
                        setSelectedProductAndService(null);
                        setSelectedUnitsAndHours(null);
                        setShowUnitsSection(false);
                        setShowHoursSection(false);
                        setShowSquaresSection(false);
                        setShowFixedSection(false);
                        setSelectedAdminId("");
                        handleRemoveFile();
                        setInputValue(searchInput || "");
                      }}
                      label={
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                          <AddIcon fontSize="small" aria-hidden />
                          Add Materials and Labor
                        </span>
                      }
                    />
                  </Grid>
                ),
              }}
              value={displayValue}
              inputValue={searchInput}
              menuIsOpen={menuIsOpen[index]}
              onMenuOpen={() => {
                const newMenuState = Array(menuIsOpen.length).fill(false);
                newMenuState[index] = true;
                setMenuIsOpen(newMenuState);
              }}
              onMenuClose={() => {
                const newMenuState = [...menuIsOpen];
                newMenuState[index] = false;
                setMenuIsOpen(newMenuState);
                // JOB-3436 (Issue A): if the user blurs without selecting an
                // option, clear the typed query so re-focusing starts fresh.
                // Previously react-select retained the value via inputValue
                // prop, which made it disappear visually on blur but reappear
                // on focus — neither expected behaviour.
                if (!item?.Name) {
                  setSearchInput("");
                  markFieldTouched("Name");
                }
              }}
              onInputChange={(inputValue, { action }) => {
                if (action === "input-change") {
                  setSearchInput(inputValue);
                  handleSearchInputChange(inputValue);
                  if (!inputValue) {
                    const newMenuState = [...menuIsOpen];
                    newMenuState[index] = false;
                    setMenuIsOpen(newMenuState);
                  }
                }
              }}
              onChange={(selectedOption) => {
                handleSelectChange(index, selectedOption);
                setSearchInput("");
                const newMenuState = [...menuIsOpen];
                newMenuState[index] = false;
                setMenuIsOpen(newMenuState);
                if (selectedOption?.Name) {
                  setTouchedLineItems((prev) => ({
                    ...prev,
                    [index]: {
                      ...prev[index],
                      Name: false,
                    },
                  }));
                }
              }}
            />
          </div>
          <InputText
            value={item?.Description || ""}
            onChange={(e) => handleInputChange(e, "Description")}
            name={`Description[${index}]`}
            label="Description"
            placeholder="Enter description"
            type="text"
            className="w-100 textarea-description gl-line-item-field"
            multiline
            minRows={3}
            fullWidth
            fieldHeight="100px"
          />
        </FormSectionCard>
      </Col>
      <Col className="col-lg-3 col-md-6 col-sm-12 col-12 mb-0 qty" lg={3} md={6} sm={12} xs={12}>
        <div
          ref={unitDropdownRef}
          className="hourQuoteBoxes gl-line-item-qty-col"
          style={{ marginBottom: 0 }}
        >
          <InputText
            value={qtyDisplayValue}
            onChange={(e) => {
              handleInputChange(e, qtyKey);
              if (e.target.value && Number(e.target.value) > 0) {
                setTouchedLineItems((prev) => ({
                  ...prev,
                  [index]: {
                    ...prev[index],
                    [qtyKey]: false,
                  },
                }));
              }
            }}
            onInput={(e) => {
              if (e.target.value < 0) {
                e.target.value = 0;
                handleInputChange(e, qtyKey);
              }
            }}
            onBlur={() => {
              markFieldTouched(qtyKey);
            }}
            label={currentUnitType}
            required
            placeholder={getPlaceholderText(currentUnitType)}
            id={`qty_${index}`}
            name={`${qtyKey}[${index}]`}
            type="number"
            className="w-100 gl-line-item-field hour_squre_unit"
            fieldHeight="60px"
            min="0"
            disable={false}
            error={qtyFieldInvalid}
            helperText={undefined}
            endAdornment={
              <button
                type="button"
                className="gl-line-item-chevron-btn"
                onClick={(e) => {
                  e.preventDefault();
                  // JOB-3432: pass the event so the popover can anchor to
                  // the chevron rather than spawn a separate field below.
                  handleDropdownToggle(e);
                }}
                aria-label="Choose unit type"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden
                >
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </button>
            }
          />
          {/* JOB-3385: InputText hides inline `helperText` whenever `error`
              is true (project-wide rule — red border is the only error
              affordance inside the field). That left a negative-clamped-
              to-0 value with no explanation. Render the message
              externally so it shows up below the field. */}
          {qtyFieldInvalid && (
            <div
              className="cs-field-helper cs-field-helper--error"
              role="alert"
              style={{ marginTop: 4 }}
            >
              {currentUnitType || "Quantity"} must be greater than 0
            </div>
          )}
          {/* JOB-3432: render unit-type options as a MUI Menu anchored to the
              chevron button. Replaces the prior inline <InputText select />
              that was rendered below the qty input and looked like a
              duplicate field. */}
          <Menu
            anchorEl={unitMenuAnchor}
            open={openDropdown && Boolean(unitMenuAnchor)}
            onClose={() => setOpenDropdown(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            MenuListProps={{ dense: true }}
          >
            {["Unit", "Hourly", "Fixed", "Sq. Ft.", "Square"].map((opt) => (
              <MenuItem
                key={opt}
                selected={opt === currentUnitType}
                onClick={() => handleDropdownChange({ target: { value: opt } })}
              >
                {opt}
              </MenuItem>
            ))}
          </Menu>
        </div>

        <div className="gl-line-item-file-wrap">
          <div className="cs-form-field gl-line-item-file-field">
            <label
              className="cs-field-label"
              htmlFor={`single-attachment-${index}`}
            >
              Attachment
            </label>
            <File
              key={`file_${index}`}
              file={item.Attachment}
              index={index}
              dropZoneClassName="gl-line-item-file-drop"
              dropZoneSolidBorder
              setFile={(index, value) => {
                const newLineItems = [...lineItems];
                if (value === "") {
                  newLineItems[index].Attachment = "";
                } else {
                  newLineItems[index].Attachment = value;
                }
                setLineItems(newLineItems);
              }}
              allowedFileTypes={["image/jpeg", "image/jpg", "image/png"]}
              allowedFileExtensions={[".jpg", ".jpeg", ".png"]}
            />
          </div>
        </div>
      </Col>

      <Col className="col-lg-2 col-md-6 col-sm-6 col-12 px-1" lg={2} md={6} sm={6} xs={12}>
        <FormGroup className="price_padding_re costInPutDetailHereToWrite">
          {currentUnitType === "Unit" ? (
            <FormGroup className="cost_input">
              <DollerInput
                label="Price"
                required
                className="mb-0 gl-line-item-currency"
                id={`CostPerUnit${index}`}
                name={`CostPerUnit[${index}]`}
                placeholder="Cost"
                type="number"
                value={item.CostPerUnit || ""}
                fieldHeight="60px"
                onBlur={() => {
                  markFieldTouched("CostPerUnit");
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value < 0) {
                    e.target.value = 0;
                  }
                  handleInputChange(e, "CostPerUnit");
                  // Clear error if value is entered
                  if (value && Number(value) > 0) {
                    setTouchedLineItems(prev => ({
                      ...prev,
                      [index]: {
                        ...prev[index],
                        CostPerUnit: false,
                      },
                    }));
                  }
                }}
                min="0"
                error={
                  (submitAttempted || isFieldTouched("CostPerUnit")) && (
                    !item.CostPerUnit || 
                    item.CostPerUnit === "" || 
                    Number(item.CostPerUnit) <= 0
                  )
                }
                helperText={undefined}
                showErrorOnly={true}
              />
            </FormGroup>
          ) : currentUnitType === "Square" ? (
            <FormGroup className="cost_input">
              <DollerInput
                label="Price"
                required
                className="mb-0 gl-line-item-currency"
                id={`CostPerSquare${index}`}
                name={`CostPerSquare[${index}]`}
                placeholder="Cost"
                type="number"
                value={item.CostPerSquare || ""}
                fieldHeight="60px"
                onBlur={() => {
                  markFieldTouched("CostPerSquare");
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value < 0) {
                    e.target.value = 0;
                  }
                  handleInputChange(e, "CostPerSquare");
                  // Clear error if value is entered
                  if (value && Number(value) > 0) {
                    setTouchedLineItems(prev => ({
                      ...prev,
                      [index]: {
                        ...prev[index],
                        CostPerSquare: false,
                      },
                    }));
                  }
                }}
                min="0"
                error={
                  (submitAttempted || isFieldTouched("CostPerSquare")) && (
                    !item.CostPerSquare || 
                    item.CostPerSquare === "" || 
                    Number(item.CostPerSquare) <= 0
                  )
                }
                helperText={undefined}
                showErrorOnly={true}
              />
            </FormGroup>
          ) : currentUnitType === "Fixed" ? (
            <FormGroup className="cost_input">
              <DollerInput
                label="Price"
                required
                className="mb-0 gl-line-item-currency"
                id={`CostPerFixed${index}`}
                name={`CostPerFixed[${index}]`}
                placeholder="Cost"
                type="number"
                value={item.CostPerFixed || ""}
                fieldHeight="60px"
                onBlur={() => {
                  markFieldTouched("CostPerFixed");
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value < 0) {
                    e.target.value = 0;
                  }
                  handleInputChange(e, "CostPerFixed");
                  // Clear error if value is entered
                  if (value && Number(value) > 0) {
                    setTouchedLineItems(prev => ({
                      ...prev,
                      [index]: {
                        ...prev[index],
                        CostPerFixed: false,
                      },
                    }));
                  }
                }}
                min="0"
                error={
                  (submitAttempted || isFieldTouched("CostPerFixed")) && (
                    !item.CostPerFixed || 
                    item.CostPerFixed === "" || 
                    Number(item.CostPerFixed) <= 0
                  )
                }
                helperText={undefined}
                showErrorOnly={true}
              />
            </FormGroup>
          ) : currentUnitType === "Sq. Ft." ? (
            <FormGroup className="cost_input">
              <DollerInput
                label="Price"
                required
                className="mb-0 gl-line-item-currency"
                id={`CostPerSquare${index}`}
                name={`CostPerSquare[${index}]`}
                placeholder="Cost"
                type="number"
                value={item.CostPerSquare || ""}
                fieldHeight="60px"
                onBlur={() => {
                  markFieldTouched("CostPerSquare");
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value < 0) {
                    e.target.value = 0;
                  }
                  const newLineItems = [...lineItems];
                  newLineItems[index].CostPerSquare = value;
                  const sqft = Number(newLineItems[index].Unit) || 1;
                  const price = Number(value) || 0;
                  newLineItems[index].Total = sqft * price;
                  setLineItems(newLineItems);
                  // Clear error if value is entered
                  if (value && Number(value) > 0) {
                    setTouchedLineItems(prev => ({
                      ...prev,
                      [index]: {
                        ...prev[index],
                        CostPerSquare: false,
                      },
                    }));
                  }
                }}
                min="0"
                error={
                  (submitAttempted || isFieldTouched("CostPerSquare")) && (
                    !item.CostPerSquare || 
                    item.CostPerSquare === "" || 
                    Number(item.CostPerSquare) <= 0
                  )
                }
                helperText={undefined}
                showErrorOnly={true}
              />
            </FormGroup>
          ) : (
            <FormGroup className="cost_input">
              <DollerInput
                label="Price"
                required
                className="mb-0 gl-line-item-currency"
                id={`CostPerHour${index}`}
                name={`CostPerHour[${index}]`}
                placeholder="Cost"
                type="number"
                value={item.CostPerHour !== undefined ? item.CostPerHour : ""}
                fieldHeight="60px"
                onBlur={() => {
                  markFieldTouched("CostPerHour");
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value < 0) {
                    e.target.value = 0;
                  }
                  handleInputChange(e, "CostPerHour");
                  // Clear error if value is entered
                  if (value && Number(value) > 0) {
                    setTouchedLineItems(prev => ({
                      ...prev,
                      [index]: {
                        ...prev[index],
                        CostPerHour: false,
                      },
                    }));
                  }
                }}
                min="0"
                error={
                  (submitAttempted || isFieldTouched("CostPerHour")) && (
                    !item.CostPerHour || 
                    item.CostPerHour === "" || 
                    Number(item.CostPerHour) <= 0
                  )
                }
                helperText={undefined}
                showErrorOnly={true}
              />
            </FormGroup>
          )}
        </FormGroup>
      </Col>
      <Col className="col-lg-2 col-md-6 col-sm-6 col-12 px-1 price_padding_re" lg={2} md={6} sm={6} xs={12}>
        <FormGroup className="cost_input DollerInput totalPaddin">
          <DollerInput
            label="Total"
            required
            className="mb-0 gl-line-item-currency"
            id={`total_${index}`}
            name={`Total[${index}]`}
            placeholder="Total"
            type="number"
            // JOB-3383: `item.Total || ""` collapsed a recalculated 0 into ""
            // (placeholder reappears), so even after the recalc fix Total
            // looked like "no value" instead of $0.00. Use nullish coalesce
            // so an explicit 0 passes through.
            value={item.Total ?? ""}
            readOnly={true}
            min="0"
            fieldHeight="60px"
            error={
              (submitAttempted || isFieldTouched("Total")) && (
                !item.Total || 
                item.Total === "" || 
                Number(item.Total) <= 0
              )
            }
            helperText={undefined}
            showErrorOnly={true}
          />
        </FormGroup>

        {lineItems.length > 1 && (
          <div className="dustbinIconDelere">
            <IconButton
              type="button"
              size="small"
              aria-label="Remove line item"
              onClick={() => deleteLineItem(index)}
              className="gl-line-item-delete-btn"
              sx={{
                color: "var(--red, #dc2626)",
                p: "6px",
                border: "1px solid",
                borderColor: "rgba(220, 38, 38, 0.28)",
                borderRadius: "8px",
                bgcolor: "rgba(254, 242, 242, 0.92)",
                boxShadow: "none",
                "&:hover": {
                  bgcolor: "rgba(254, 226, 226, 0.98)",
                  borderColor: "rgba(220, 38, 38, 0.48)",
                },
              }}
            >
              <DeleteOutlineRoundedIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </div>
        )}
      </Col>
      <AddItems
        modelOpen={modelOpen}
        setModelOpen={setModelOpen}
        setSelectedProductAndService={setSelectedProductAndService}
        selectedProductAndService={selectedProductAndService}
        productsAndService={productsAndService}
        setShowUnitsSection={setShowUnitsSection}
        setShowHoursSection={setShowHoursSection}
        setSelectedUnitsAndHours={setSelectedUnitsAndHours}
        showHoursSection={showHoursSection}
        showUnitsSection={showUnitsSection}
        selectedUnitsAndHours={selectedUnitsAndHours}
        UnitsAndHours={UnitsAndHours}
        showSquaresSection={showSquaresSection}
        setShowSquaresSection={setShowSquaresSection}
        showFixedSection={showFixedSection}
        setShowFixedSection={setShowFixedSection}
        CompanyId={getItem("CompanyId") || tokenDecode?.companyId}
        getData={getProducts}
        handleDragOver={handleFileDragOver}
        handleDrop={handleFileDrop}
        setLineItems={setLineItems}
        setNew={true}
        handleSelectChange={handleSelectChange}
        index={index}
        /* JOB-3436 (Issue B): forward the seeded value so the modal's Name
           field pre-fills with the user's typed query (e.g. "Services").
           Setting setInputValue alone was a no-op for the modal because
           the prop the modal reads (inputValue) was never passed. */
        inputValue={inputValue}
        setInputValue={setInputValue}
        setSearchInput={setSearchInput}
        handleCloseModal={handleCloseModal}
        handleFileChange={handleFileChange}
        uploadFile={uploadFile}
        file={file}
        error={error}
        closePreviewModal={closePreviewModal}
        previewFile={previewFile}
        handleFilePreview={handleFilePreview}
        handleRemoveFile={handleRemoveFile}
        previewModalOpen={previewModalOpen}
        selectedProduct={selectedProduct}
        setSelectedProduct={setSelectedProduct}
        selectedAdminId={selectedAdminId}
      />
    </Row>
  );
};

export default GetProducts;
